import { RECOMMEND_REVIEW_TYPE } from '../../../../constants/service/app/recommendReviewConstants';
import { _LIST_PAGINATION_MODEL } from '../../app/models';

/**
 *  추천 상품 후기 리스트 검색 박스 모델
 */
export const RECOMMEND_REVIEW_LIST_SEARCH_DATA_MODEL = {
  /**
   *  추천 상품 후기 타입
   */
  recommendReviewType: RECOMMEND_REVIEW_TYPE.SEARCH_RECOMMEND,
  /**
   *  추천인
   */
  adminName: null,
  /**
   *  메모
   */
  memo: null,
  /**
   *  추천 상품 후기 생성일
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  추천 상품 후기 리스트 검색 옵션 모델
 */
export const RECOMMEND_REVIEW_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  추천 상품 후기 타입
   */
  recommendReviewType: RECOMMEND_REVIEW_TYPE.SEARCH_RECOMMEND,
  /**
   *  추천인
   */
  adminName: null,
  /**
   *  메모
   */
  memo: null,
  /**
   *  추천 상품 후기 생성일
   */
  createDate: null,
};

/**
 *  추천 상품 후기에 연결할 아이템 리스트 필터 옵션 모델
 */
export const RECOMMEND_REVIEW_ITEM_LIST_FILTER_OPTION_MODEL = {
  /**
   *  상품 후기 번호
   */
  reviewId: null,
  /**
   *  상품 번호
   */
  productId: null,
  /**
   *  상품명
   */
  productName: null,
  /**
   *  상품 후기의 상점명
   */
  storeName: null,
  /**
   *  상품 후기의 상점 ID
   */
  storeId: null,
};

/**
 *  추천 상품 후기에 연결할 아이템 리스트 필터 정렬 모델
 */
export const RECOMMEND_REVIEW_ITEM_LIST_SORT_OPTION_MODEL = {
  /**
   *  별점
   */
  rate: 'descend',
  /**
   *  생성일
   */
  createDate: null,
};

/**
 *  추천 상품 후기 등록/복사 모델
 */
export const RECOMMEND_REVIEW_SAVE_MODEL = {
  /**
   *  추천 상품 후기 정보
   */
  recommendReviewInfo: {
    /**
     *  추천 상품 후기 타입
     */
    type: RECOMMEND_REVIEW_TYPE.SEARCH_RECOMMEND,
    /**
     *  메모
     */
    memo: null,
  },
  /**
   *  추천 상품 후기 아이템 리스트
   */
  recommendReviewItemList: {
    /**
     *  추천 상품 후기에 연결할 아이템 리스트
     */
    itemList: {
      /**
       * 리스트
       */
      list: [],
      /**
       *  필터 옵션
       */
      filterOption: RECOMMEND_REVIEW_ITEM_LIST_FILTER_OPTION_MODEL,
      /**
       *  정렬 옵션
       */
      sortOption: RECOMMEND_REVIEW_ITEM_LIST_SORT_OPTION_MODEL,
      /**
       * pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    },
    /**
     *  선택된 추천 상품 후기에 연결된 아이템 리스트
     */
    selectedItemList: {
      list: [],
      idList: [],
    },
  },
};
